"use client"

import { useApi, API_ENDPOINTS, transformPascalToCamel } from "@/lib/api"
import type { AtsDestinationFieldInfo } from "@/types/fbo-api"
import type { FboTargetMappingConfiguration, TargetSheetSpec } from "@/types/target-mapping"

export function useTargetMapping() {
  const { mainApi } = useApi()

  const loadTargetNames = async (): Promise<string[]> => {
    return mainApi.get<string[]>(API_ENDPOINTS.MAIN.TARGET_NAMES)
  }

  const loadTargetSpec = async (targetName: string): Promise<TargetSheetSpec[]> => {
    const response = await mainApi.get<any>(API_ENDPOINTS.MAIN.TARGET_SPECS(targetName))
    return transformPascalToCamel(response) as TargetSheetSpec[]
  }

  const loadTargetSourceFields = async (mappingName: string): Promise<AtsDestinationFieldInfo[]> => {
    return mainApi.get<AtsDestinationFieldInfo[]>(API_ENDPOINTS.MAIN.TARGET_SOURCE_FIELDS(mappingName))
  }

  const loadTargetMapping = async (targetName: string): Promise<FboTargetMappingConfiguration> => {
    const response = await mainApi.get<any>(API_ENDPOINTS.MAIN.TARGET_MAPPINGS(targetName))
    return transformPascalToCamel(response) as FboTargetMappingConfiguration
  }

  const saveTargetMapping = async (targetName: string, config: FboTargetMappingConfiguration): Promise<boolean> => {
    try {
      await mainApi.post(API_ENDPOINTS.MAIN.TARGET_MAPPINGS(targetName), config)
      return true
    } catch (err) {
      console.error("Failed to save target mapping configuration:", err)
      return false
    }
  }

  return { loadTargetNames, loadTargetSpec, loadTargetSourceFields, loadTargetMapping, saveTargetMapping }
}
